namespace advisorop.components.advisor {

    class AdvisorCrudWrapperController {

        $router;
        public model: domains.IAdvisor;
        advisory: domains.IAdvisor;
        rolesNames: any;
        selectedCompanyGroup: domains.ICompanyGroup;
        advisorId: number;
        static $inject = ["identityService","generalService", "advisorService"];
        constructor(private identityService: services.IdentityService,
            private generalService: services.GeneralService, private advisorService: services.AdvisorService) {

        }

        companyGroupSelected(companyGroup: domains.ICompanyGroup): void {
            this.selectedCompanyGroup = companyGroup;
        };
        
        $onInit(): void {        
        }


        $routerOnActivate(next, previous) {
            if (next.params.advisorId) {
                this.advisorId = next.params.advisorId;
            }
        }
    }

 
    class AdvisorCrudWrapper implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;

        constructor() {
            this.bindings = {
                "$router": "<"
            };
            this.controller = AdvisorCrudWrapperController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/advisor-module/views/advisor-crud-wrapper.html';
        }
    }
    angular.module(Constants.APP).component("advisorCrudWrapper", new AdvisorCrudWrapper());


}